import { DOCUMENT } from "@angular/common";
import {
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnInit,
} from "@angular/core";
import { DialogService } from "@career/core/services/dialog.service";
import { UserService } from "../services/user.service";

@Directive({
  selector: "[appVideoEditContainer]",
})
export class VideoEditContainerDirective implements OnInit {
  @Input() appVideoEditContainer: string;
  @Input() currentUrl: string = "";
  @Input() name: string = "Video";
  isAdmin = false;

  constructor(
    private el: ElementRef,
    private dialogSvc: DialogService,
    private userSvc: UserService,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    this.userSvc.isAdmin().subscribe((response) => {
      this.isAdmin = response;
      if (this.el.nativeElement.classList.contains("_editable")) {
        this.el.nativeElement.classList.remove("_editable");
        const spanElem = this.el.nativeElement.querySelector("._editable__heading");
        if (spanElem) {
          this.el.nativeElement.removeChild(spanElem);
        }
      }
      if (this.isAdmin) {
        this.renderBodyBorder();
      }
    });
  }

  renderBodyBorder(): void {
    this.el.nativeElement.classList.add("_editable");
    const caption = this.document.createElement("span");
    caption.setAttribute("class", "_editable__heading");
    caption.innerHTML = this.name;
    this.el.nativeElement.appendChild(caption);
  }

  @HostListener("click", ["$event"])
  onClick(e: PointerEvent) {
    if (!this.isAdmin) {
      return;
    }
    this.dialogSvc.editVideoDialog(
      this.appVideoEditContainer,
      this.currentUrl,
      this.name,
      e,
      this.el
    );
  }
}
